import styled from 'styled-components';

export const PageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: var(--surface);
`;
export const StyledSignupForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
`;

export const CardTextSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const CardFormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
